import React, { useEffect } from 'react'

import { useRecoilValue } from 'recoil'

import { TooltipUtils } from 'mailup-web-components'

import { timelineFilteredState } from 'Pages/ScheduledSendings/recoil/state/calendar'

import TimelineSendingItem from './TimelineSendingItem'

const TimelineSendings = () => {
  const sendings = useRecoilValue(timelineFilteredState)

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [sendings])

  return sendings.map((s, index) => (
    <TimelineSendingItem
      key={s.id}
      {...s}
      isLast={index === sendings.length - 1}
    />
  ))
}

export default TimelineSendings
